<template>
  <div class="captiontext">
    <div
      :style="{
        background: datas.backColor,
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px',
      }"
      @click="handleClickName"
    >
      <!-- 标题 -->
      <div
        v-if="datas.name"
        :style="{
          'font-size': datas.wordSize + 'px',
          'font-weight': datas.isBold ? 'bold' : 'normal',
          'font-style': datas.isTilt ? 'italic' : 'normal',
          'text-decoration': datas.isUnderLine ? 'underline' : 'none',
          color: datas.wordColor,

          '--bgColor': datas.lineColor,
        }"
        :class="'class_title_con class_title_' + datas.styleType"
      >
        {{ datas.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { handleScanCode } from "@/utils";
export default {
  name: "Captiontext",
  props: {
    datas: Object,
  },
  methods: {
    handleClickName() {
      // if (!this.datas.linkUrl&&this.datas.linkType!='scanCode') return;

      if (this.datas.linkType == "scanCode") {
        // 调起微信扫码，扫码取号并自动跳转到扫码信息页面
        handleScanCode();
      } else if (this.datas.linkUrl) {
        window.location.href = this.datas.linkUrl;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.captiontext {
  border: 2px solid #fff;
  box-sizing: border-box;
  width: 100%;
  min-height: 20px;
  position: relative;

  .class_title_con {
    position: relative;
    box-sizing: border-box;
    &.class_title_1 {
      padding-left: 15px;
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        margin-top: -15px;
        width: 4px;
        height: 28px;
        border-radius: 2px;
        background-color: var(--bgColor);
      }
    }
    &.class_title_2 {
      text-align: center;
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        width: 32%;
        height: 1px;
        border-radius: 2px;
        background-color: var(--bgColor);
      }
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        right: 0;
        width: 32%;
        height: 1px;
        border-radius: 2px;
        background-color: var(--bgColor);
      }
    }
    &.class_title_3 {
      text-align: center;
      &::after {
        content: "";
        position: absolute;
        bottom: -7px;
        left: 0;
        width: 100%;
        height: 1px;
        border-radius: 2px;
        background-color: var(--bgColor);
      }
    }
    &.class_title_4 {
      font-family: "iconfont";
      &::after {
        content: "\e775";
        position: absolute;
        top: 0;
        right: 0;
        width: 10px;
        height: 100%;
        color: var(--bgColor);
      }
    }
  }

  /* 更多 */
  .more {
    font-size: 10px;
    color: #969799;
    text-align: center;
    &.lef {
      position: absolute;
      right: 15px;
      top: 12px;
    }
  }
}
</style>
